import type { FilterOption } from '@/components/filters/FilterDropdown';

/** Value sent as `appName` for supplier-portal (matches backend `AppName.SUPPLIER_PORTAL`). */
export const SUPPLIER_APP_NAME = 'supplier-portal' as const;

export const ROLES = {
  SYSTEM_ADMIN: '8EC4C6AE-A070-4A37-ACA2-9DF61B8844C8',
  BOOKING_REQUESTER: '40D00BD0-C67E-45C7-9CCC-00CEE0BBB9F8',
} as const;

export const BOOKED_STATUS_OPTIONS: FilterOption[] = [
  { id: 'yes', label: 'Yes' },
  { id: 'no', label: 'No' },
];
